/**
 * @param {string} hex
 */
export function luma(hex) {
  const [r, g, b] = hextorgb(hex)
  return 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709
}

/**
 * @param {string} hex
 * @returns {[number, number, number]}
 */
export function hextorgb(hex) {
  const match = hex.match(/^#?([a-fA-F0-9]{6})$/)
  if (!match) throw new Error(`Invalid HEX color code: ${hex}`)
  const rgb = parseInt(match[1], 16) // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff // extract red
  const g = (rgb >> 8) & 0xff // extract green
  const b = (rgb >> 0) & 0xff // extract blue
  return [r, g, b]
}
